import BaseStore from './BaseStore'

export class CampusStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'campuses'
  }
}

export default new CampusStore()


// WEBPACK FOOTER //
// ./src/stores/CampusStore.js